//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TransientObject.js";
import "../no/MeasureManager.js";
let d=[[[0,"MeasurementType",0,0]],[[[],"Dispose",{},0,0],[[],"Information",{},0,0]],[]];
SPLM.GenericMeasure = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GenericMeasure";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GenericMeasure.Type = Object.freeze({
    "MinimumDistance" : "MinimumDistance", "LocalMinimumDistance" : "LocalMinimumDistance", "MaximumDistance" : "MaximumDistance", "ProjectedDistance" : "ProjectedDistance", "RadialDistance" : "RadialDistance", "Length" : "Length", "TwoObjectAngle" : "TwoObjectAngle", "ThreePointAngle" : "ThreePointAngle", "FaceProperties" : "FaceProperties", "MassProperties" : "MassProperties", "PointsOnCurves" : "PointsOnCurves", "RoutingPathLength" : "RoutingPathLength", "DiameterDistance" : "DiameterDistance", "PolarRadius" : "PolarRadius", "PolarAngle" : "PolarAngle", "RectangularExtreme" : "RectangularExtreme", "PolarArea" : "PolarArea", "ExtremePoint" : "ExtremePoint", "MinimumSmartDistance" : "MinimumSmartDistance", "MaximumSmartDistance" : "MaximumSmartDistance", "Point" : "Point"});

export default SPLM;